export const formFieldPresence = {
  hidden: { opacity: 0, height: 0, y: -80 },
  visible: { opacity: 1, height: 'auto', y: 0 },
  exit: { opacity: 0, height: 0 },
};
